<template>
    <div>
        <v-menu>
            <template v-slot:activator="{ props }">
                <v-btn
                    icon
                    v-bind="props"
                    v-html="current.flag"
                    v-tooltip.bottom-center="$t('langpicker.change')"
                    class="flag-btn"
                ></v-btn>
            </template>
            <v-list>
                <v-list-item
                    v-for="(lang, key) in messages"
                    :key="key"
                    @click="changeLanguage(key as string)"
                >
                    <template #prepend>
                        <v-avatar rounded="0" size="24" v-html="lang.flag"></v-avatar>
                    </template>
                    <v-list-item-title>{{ lang.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits<{
  change: [];
}>();

const { locale, messages } = useI18n({ useScope: 'global' });

const current = computed(() => (messages.value as any)[locale.value]);

const changeLanguage = (key: string) => {
    locale.value = key;
    localStorage.setItem('language', key);
    emit('change');
};
</script>

<style lang="scss">
.flag-btn svg{
    max-height: 20px;
}
</style>